import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#4C6FFF',
                primaryTextColor: '#4C6FFF',
                primaryBackgroundColor: '#FFFFFF',
                secondaryBackgroundColor: '#F3F5F8',
                scrollbar: '#727272',
                error: '#F16063',
                success: '#66CB9F',
                lightRed: '#FF726',
                red: '#D43B1B',
                green: '#27AE60',
                label: '#16192C',
                fiord: '#425466',
                gray: '#718096'
            },
            dark: {
                primary: '#4C6FFF',
                primaryTextColor: '#FFFFFF',
                primaryBackgroundColor: '#293143',
                secondaryBackgroundColor: '#252736',
                scrollbar: '#A6A6A6',
                error: '#F16063',
                success: '#66CB9F',
                lightRed: '#FF726',
                red: '#D43B1B',
                green: '#27AE60',
                label: '#16192C',
                fiord: '#425466',
                gray: '#718096'
            }
        }
    }
});
